import { render, staticRenderFns } from "./VerificationDetail.vue?vue&type=template&id=7bb5498a&"
import script from "./VerificationDetail.vue?vue&type=script&lang=js&"
export * from "./VerificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDetail.vue?vue&type=style&index=0&id=7bb5498a&prod&lang=css&"
import style1 from "./VerificationDetail.vue?vue&type=style&index=1&id=7bb5498a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports